export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    fixed: 'right',
    width: 100,
    slots: { default: 'opt' },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_pdProcessDictNo') || '字典编号',
    field: 'pdProcessDictNo',
    width: 160,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_masterCategory') || '主分类',
    field: 'masterCategoryName',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_category') || '明细分类',
    field: 'categoryName',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_processDictName') || '字典名称',
    field: 'processDictName',
    minWidth: 220,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_pdPerson') || '工艺师',
    field: 'pdPersonName',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_pdProcessDictStatus') || '工艺字典状态',
    width: 100,
    align: 'center',
    slots: { default: 'status' },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_remark') || '备注说明',
    field: 'remark',
    minWidth: 250,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'createByName',
    headerAlign: 'center',
    align: 'center',
    width: 150,
    title: that.$l('INDEX.creator') || '创建人',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'createTime',
    align: 'center',
    width: 170,
    title: that.$l('INDEX.create_date') || '创建时间',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'modifyByName',
    align: 'center',
    width: 150,
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'modifyTime',
    align: 'center',
    width: 170,
    title: that.$l('INDEX.table_label_modification_date') || '修改时间',
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
